// Production
export const TOKEN_ADDRESSES = {
	LINK: "0x88Fb150BDc53A65fe94Dea0c9BA0a6dAf8C6e196",
	USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
	CREDIT: "0x8fF237B5e0a5a177f8BaD0D58A0561119b2DCd68",
} as const;

export const ERC20_ABI = [
	{
		inputs: [{ name: "owner", type: "address" }],
		name: "balanceOf",
		outputs: [{ name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
] as const;
